import React from "react";
import Info from "@mui/icons-material/Info";
import { SvgIconProps } from "@mui/material";

const InfoIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <Info
      ref={ref}
      sx={{ pointerEvents: "auto", cursor: "pointer" }}
      {...props}
    />
  );
});

export default InfoIcon;
